import React, { useState } from 'react';
import './Navbar.css';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';

const services = [
  { name: 'Automatic Car Wash (With Optional Hydrophobic Coating)', slug: 'automatic-car-wash' },
  { name: 'Ceramic Coating', slug: 'ceramic-coating' },
  { name: 'Graphene Coating', slug: 'graphene-coating' },
  { name: 'Borophene Coating', slug: 'borophene-coating' },
  { name: 'Paint Protection Film (PPF)', slug: 'paint-protection-film' },
  { name: 'Windshield Protection Film', slug: 'windshield-protection-film' },
  { name: 'Sprayable PPF', slug: 'sprayable-ppf' },
  { name: 'Detailing Services', slug: 'detailing-services' },
  { name: 'Deep Interior Cleaning', slug: 'deep-interior-cleaning' },
  { name: 'Steam Wash', slug: 'steam-wash' },
  { name: 'Bike Detailing', slug: 'bike-detailing' },
  { name: 'Window Films', slug: 'window-films' },
  { name: 'Painting & Denting Services', slug: 'painting-denting-services' },
  { name: 'Car Modifications', slug: 'car-modifications' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ left: 0, top: 0, width: 0 });
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = React.useRef();
  const parentRef = React.useRef();

  // Close dropdown on mobile menu close
  const handleMenuToggle = () => {
    setMenuOpen((open) => !open);
    if (menuOpen) setServicesOpen(false);
  };

  // Dropdown open on hover (desktop), on click (mobile)
  const handleServicesClick = (e) => {
    if (window.innerWidth <= 900) {
      e.preventDefault();
      setServicesOpen((open) => !open);
    }
  };

  // Determine if SERVICES should be active
  const isServicesActive = location.pathname === '/service' || location.pathname.startsWith('/services/');

  // Get the current sub service slug if on a sub service page
  let activeServiceSlug = null;
  if (location.pathname.startsWith('/services/')) {
    activeServiceSlug = location.pathname.split('/')[2];
  }

  // Position the dropdown when opening
  React.useEffect(() => {
    if (servicesOpen && parentRef.current) {
      const rect = parentRef.current.getBoundingClientRect();
      setDropdownPos({
        left: rect.left,
        top: rect.bottom,
        width: rect.width
      });
    }
  }, [servicesOpen]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button
          className="navbar-menu-btn"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={handleMenuToggle}
        >
          {menuOpen ? (
            <span className="navbar-menu-x">&#10005;</span>
          ) : (
            <span className="navbar-menu-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          )}
        </button>
        <ul className={`navbar-links${menuOpen ? ' open' : ''}`}>
          <li>
            <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>HOME</NavLink>
          </li>
          <li>
            <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>ABOUT</NavLink>
          </li>
          <li
            className={`navbar-dropdown-parent${servicesOpen ? ' open' : ''}`}
            ref={parentRef}
            onMouseEnter={() => window.innerWidth > 900 && setServicesOpen(true)}
            onMouseLeave={() => window.innerWidth > 900 && setServicesOpen(false)}
          >
            <span
              className={`navbar-dropdown-link${isServicesActive ? ' active' : ''}`}
              onClick={e => {
                if (window.innerWidth > 900) {
                  navigate('/service');
                } else {
                  handleServicesClick(e);
                }
              }}
              aria-haspopup="true"
              aria-expanded={servicesOpen}
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  if (window.innerWidth > 900) {
                    navigate('/service');
                  } else {
                    handleServicesClick(e);
                  }
                }
              }}
            >
              SERVICES <span className="navbar-dropdown-arrow">▼</span>
            </span>
            {/* Portal for dropdown */}
            {servicesOpen && createPortal(
              <ul
                className={`navbar-dropdown show`}
                ref={dropdownRef}
                style={{
                  position: 'absolute',
                  left: dropdownPos.left,
                  top: dropdownPos.top,
                  minWidth: dropdownPos.width,
                  zIndex: 400001
                }}
                onMouseEnter={() => window.innerWidth > 900 && setServicesOpen(true)}
                onMouseLeave={() => window.innerWidth > 900 && setServicesOpen(false)}
              >
                {services.map((service) => (
                  <li key={service.slug} onClick={() => { setMenuOpen(false); setServicesOpen(false); navigate(`/services/${service.slug}`); }}>
                    <span className={activeServiceSlug === service.slug ? 'active' : ''}>{service.name}</span>
                  </li>
                ))}
              </ul>,
              document.body
            )}
          </li>
           <li>
            <NavLink to="/product" className={({ isActive }) => isActive ? 'active' : ''}>PRODUCT</NavLink>
          </li>
          <li>
            <NavLink to="/packages" className={({ isActive }) => isActive ? 'active' : ''}>PACKAGES</NavLink>
          </li>
          <li>
            <NavLink to="/channelPartner" className={({ isActive }) => isActive ? 'active' : ''}>CHANNEL PARTNERS</NavLink>
          </li>
          <li>
            <NavLink to="/gallery" className={({ isActive }) => isActive ? 'active' : ''}>GALLERY</NavLink>
          </li>
           <li>
            <NavLink to="/blogs" className={({ isActive }) => isActive ? 'active' : ''}>BLOG</NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>CONTACT</NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 